import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const generateBaseQuery = (baseURL) =>
  fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers) => {
      headers.set('client-app-id', process.env.CLIENT_APP_ID);
      return headers;
    },
  });

export default generateBaseQuery;
